export const footerWrapper = {
  background: "#0D0D2B",
  padding: "3rem",
  color: "#ffffff",
};

export const socialIconsStyle = { ":hover": { transform: "scale(1.1)" } };

export const cardPaymentsIconsStyle = {
  ":hover": { transform: "scale(1.05)" },
};

export const footerLinkStyle = {
  cursor: "pointer",
  ":hover": { opacity: 0.5 },
};
